
export function getAccessToken() {
  const jwt = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken') || '';
  return jwt;
} 

export function getRefreshToken() {
  const refreshToken = localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken') || '';
  return refreshToken;
} 

export function clearAccessToken() {
  localStorage.removeItem('accessToken');
  sessionStorage.removeItem('accessToken');
}

export function clearRefreshToken() {
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('refreshToken');
}

export function setTokens(accessToken: string, refreshToken: string, rememberMe: boolean) {
  if (rememberMe) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  } else {
    sessionStorage.setItem('accessToken', accessToken);
    sessionStorage.setItem('refreshToken', refreshToken);
  }
}

export function clearTokens() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('refreshToken');
} 

export function setTempLoginToken(tempLoginToken: string) {
  sessionStorage.setItem('tempLoginToken', tempLoginToken);
} 

export function getTempLoginToken() {
  return sessionStorage.getItem('tempLoginToken') || '';
} 